export class ContributionFilter {
    constructor(offset: number, limit: number, initialdate: any, finaldate: any) {
        this.offset = offset;
        this.limit = limit;
        this.initialdate = initialdate;
        this.finaldate = finaldate;
    }

    offset: number;
    limit: number;
    initialdate: any = null;
    finaldate: any | null = null;
}
